export default __webpack_public_path__ + "static/media/urlImage.956ca1bd.jpg";